module.exports = __webpack_public_path__ + "img/result_tips_other.8af403b8.png";